import { Component, OnInit, Input } from '@angular/core';
import { AuthenticationService } from '../../../authentication/authentication.service';
import { StoreStatement } from '../../../models/profile.model';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { DashboardService } from '../../dashboard.service';
import { NotificationBuilder } from '../../../shared/notificationBuilder';

@Component({
  selector: 'card-pipepolen',
  templateUrl: './card-pipepolen.component.html',
  styleUrls: ['./card-pipepolen.component.css']
})
export class CardPipePolenComponent implements OnInit {

  @Input() invoices: StoreStatement[]
  public isAdmin: boolean
  invoiceEdit: StoreStatement = null
  @Input() status: string

  constructor(private authenticationService: AuthenticationService, private dashboardService: DashboardService, public ngxSmartModalService: NgxSmartModalService, private notificationBuilder: NotificationBuilder) { }

  ngOnInit() {
    if (this.invoices != null)
      this.invoiceEdit = this.invoices[0]
  }

  showItem(invoiceStatus: number, storeName: string) {
    if (invoiceStatus == 3 || invoiceStatus == 4) {
      if (this.status == "3,4") {
        return true
      }
    }
    else {
      if (invoiceStatus == +this.status) {
        return true
      }
      return false
    }
    return false
  }


  showDetails(invoice: StoreStatement, event) {
    debugger
    this.invoiceEdit = invoice
    this.ngxSmartModalService.getModal('invoiceModal').open()
  }

  updateStatementInvoice(invoice: StoreStatement) {
    debugger
    this.dashboardService.updateStatementInvoice(invoice).subscribe(data => {
      if (data) {
        this.invoiceEdit = data
        this.notificationBuilder.showNotification('success', 1000, 'Fatura alterada com sucesso!')
      } else {
        this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a busca pela fatura')
      }
    })
  }

}
